<script>
export default {
    name: 'IlluEconomie',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-economie"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <path
                d="M23.495 15.083l.013.97-.79.497c-2.836 1.778-5.115 4.227-6.594 7.08l-.323.624-.649.19a4.178 4.178 0 01-1.157.146c-1.136 0-2.636-.335-4.455-.994a.419.419 0 00-.142-.027.233.233 0 00-.204.106c-.04.067-1.08 1.943 2.093 13.353.206.749.98 1.357 1.724 1.357h2.605l.45.885c1.717 3.37 4.577 6.211 8.055 8.003l.893.46V53.655c0 .742.577 1.345 1.283 1.345h3.358c.708 0 1.284-.603 1.284-1.345V49.38l1.629.04.27.01c.094.005.185.01.28.01h2.96c.134 0 .266-.005.399-.01l.163-.005 1.633-.045v4.275c0 .742.576 1.345 1.284 1.345h3.359c.707 0 1.284-.603 1.284-1.345v-5.927l.891-.46C51.203 44.112 55 38.071 55 31.502c0-1.716-.26-3.424-.775-5.073l-.38-1.21-.561-1.162c-3.084-6.373-9.839-10.492-17.205-10.492h-2.961c-.755 0-1.528.05-2.362.15l-.909.108-.547-.773c-.466-.658-2.89-3.874-5.883-4.05l.078 6.083zm9.66 8.911C32.506 23.943 32 23.517 32 23l.006-.102c.066-.504.614-.898 1.281-.898h5.426l.131.006c.65.051 1.156.476 1.156.994l-.006.102c-.066.504-.614.898-1.281.898h-5.426l-.132-.006z"
                id="a"
            />
        </defs>
        <g fill="none" fill-rule="evenodd">
            <path
                :stroke="secondaryColor" class="secondary-color"
                d="M23.925 9.595c2.67.615 4.57 3.182 4.967 3.744h0l.719 1.016 1.197-.142c1.117-.116 1.719-.148 2.31-.148h2.951c3.693.07 7.137 1.092 10.029 2.856 2.907 1.773 5.256 4.296 6.736 7.354h0l.546 1.129.365 1.167.145.49c.405 1.448.61 2.939.61 4.436-.07 3.285-1.01 6.349-2.658 8.97-1.664 2.648-4.05 4.843-6.98 6.357h0l-1.162.6v6.207a1.082 1.082 0 01-.272.646.702.702 0 01-.512.223h0-3.332a.952.952 0 01-.59-.275.816.816 0 01-.221-.57h0v-4.789l-2.14.06-3.51.013-2.684-.073v4.765a1.082 1.082 0 01-.271.646.702.702 0 01-.513.223h0-3.331a.95.95 0 01-.588-.275.817.817 0 01-.222-.57h0v-6.227l-1.154-.594c-3.592-1.95-6.238-4.63-7.848-7.791h0l-.59-1.158h-2.887a1.57 1.57 0 01-.805-.326 1.301 1.301 0 01-.461-.664c-2.396-8.72-2.371-11.709-2.235-12.614 2.144.555 3.445.809 4.461.809.668-.024 1.002-.08 1.297-.166h0l.855-.25.418-.808c1.643-2.992 3.783-5.24 6.418-6.892h0l1.028-.646-.016-1.251zM38.73 21.5l-5.604.006c-.443.033-.834.199-1.122.476-.268.258-.454.615-.493 1.185.048.37.253.71.609.96.286.2.675.342 1.15.373l5.604-.006a1.786 1.786 0 001.121-.476c.269-.258.454-.615.494-1.185-.048-.37-.253-.71-.609-.96-.285-.2-.675-.342-1.15-.373z"
            />
            <path
                d="M23.757 28.988A3.003 3.003 0 0121 26c0-1.656 1.346-3 3.003-3l.246.01A2.998 2.998 0 0127 26l-.01.247A3 3 0 0124.003 29l-.246-.012z"
                :fill="primaryColor" class="primary-color"
            />
        </g>
    </svg>
</template>
